import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect } from "../../../components/hooks";
import { KnowledgeAPI } from "../../../axios/api";

import { Button } from "primereact/button";

export default function ModulePopCountDetail({ prePopOption, closePrePop }) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState([]);

  useAbortedEffect(
    (signal) => {
      dispatch(setProgress(true));

      let params = {
        kid: prePopOption.id,
      };

      KnowledgeAPI.getKnowledgesCountsRecordMemberCountsByKid({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          setApiData(data);
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [prePopOption]
  );

  return (
    <>
      <div className="px-3">
        <table className="w-full custom-tb text-center">
          <thead>
            <tr className="bg-blue-50">
              <th className="p-2">瀏覽人員</th>
              <th className="p-2">瀏覽次數</th>
            </tr>
          </thead>
          <tbody>
            {apiData.map((item) => (
              <tr className="font-bold">
                <td className="bg-orange-50 p-2">{item.member_name}</td>
                <td className="p-2">{item.counts}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-center mt-4">
          <Button
            className="p-button-secondary p-button-sm px-3"
            type="button"
            label="關閉"
            onClick={() => closePrePop({ type: prePopOption.type })}
          />
        </div>
      </div>
    </>
  );
}
